import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'

import EntitySelectorSearch from "../../search/search"
import EntitySelectorUsersList from "./list"
import {useEntitySelectorContext} from "../../context"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import {EntityType} from "../../../../gd/const/item"

// const debug = "EntitySelectorUsers"
const debug = false

// The one tab that picks from what the host handed in rather than from a query:
// `context.userMentions` is the editor's own mention list, filtered in memory.
export default function EntitySelectorUsers () {
    const context               = useEntitySelectorContext()

    const [search, setSearch]   = useState('')
    const [options, setOptions] = useState<MentionOption[]>([])
    const listRef               = useRef<any>()

    const userMentions = useMemo(()=>{
        return _.map(context.userMentions.slice(), mention=> {
            // mention.type = EntityType.USER      // Set in MentionsManager !!!!!
            return mention
        })
    }, [context.userMentions])

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    useEffect(()=>{
        const searchString = search?.toLowerCase()

        const res: MentionOption[] = []
        _.map(userMentions, (option:any)=>{
            if (option.name.toLowerCase().includes(searchString)) res.push(option)
        })
        setOptions(res)
    }, [search])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current.onKeyDown(event)
    }, [listRef.current])

    return (
        <>
            <EntitySelectorSearch
                searchDebounceTime  = {0}
                placeholder         = "Search by user name"
                onKeyDown           = {onKeyDown}
                onSearchChanged     = {onSearchChanged}
            />
            <EntitySelectorUsersList
                ref                 = {listRef}
                search              = {search}
                options             = {options}
            />
        </>
    )
}
